export default __webpack_public_path__ + "static/media/offline.d6c99d09.svg";